import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCandidateFormationValues, postCandidateEducation, postCandidateKnowledge } from "../../../API/Candidates/Education";
import CustomInput from "../components/customInput";
import CustomSelect from "../components/customSelect";
import CustomCheckBox from "../components/customCheckBox";
import CustomDateInput from "../components/customDateInput";
import CustomRadioBtn from "../components/customRadioBtn";
import Loading from "../../../Components/Loading/Loading";
import Swal from "sweetalert2";
import { firstLoginTranslate } from "../../../i18n/translatedMessages";
import { useIntl } from "react-intl";

const Step3FirstLogin = ({ onNextStep }) => {
  const locale = useIntl().locale;
  const language = locale === "PT-BR" ? "pt" : "es";
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [checkBoxValue, setCheckBoxValue] = useState(false);
  const [dataFormation, setDataFormation] = useState({
    name: "",
    entry_date: "2000-01-01",
    university: "",
    departure_date: "2000-01-01",
    skill_level_id: "0",
  });

  const [dataEnglish, setDataEnglish] = useState({
    language: "English",
    language_level_id: "1",
  });

  const typeList_es = [
    {
      id: 1,
      name: "Técnico",
      value: 1,
    },
    {
      id: 2,
      name: "Grado universitario",
      value: 2,
    },
    {
      id: 3,
      name: "Diplomado",
      value: 3,
    },
    {
      id: 4,
      name: "MBA/Master",
      value: 4,
    },
    {
      id: 5,
      name: "Doctorado",
      value: 5,
    },
  ];

  const typeList_pt = [
    {
      id: 1,
      name: "Técnico",
      value: 1,
    },
    {
      id: 2,
      name: "Graduação",
      value: 2,
    },
    {
      id: 3,
      name: "Pós-Graduação",
      value: 3,
    },
    {
      id: 4,
      name: "MBA/Master",
      value: 4,
    },
    {
      id: 5,
      name: "Doutorado",
      value: 5,
    },
  ];

  const typeList = language === "es" ? typeList_es : typeList_pt;

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
    setDataFormation({
      ...dataFormation,
      [name]: value,
    });
  };

  const handleChangeRadio = (value) => {
    setDataEnglish((prevState) => ({
      ...prevState,
      language_level_id: value,
    }));
  };

  useEffect(() => {
    const fetchList = async () => {
      const knowledgeData = await getCandidateFormationValues(localStorage.getItem("candidateId"));
      setDataFormation(knowledgeData.items.formacions[0] ?? dataFormation);
      setDataEnglish(knowledgeData.items.languages[0] ?? dataEnglish);

      setIsLoading(false);
    };

    fetchList();
  }, []);

  const handleStartClick = async () => {
    setIsLoading(true);

    const [respKnowledge, respEducation] = await Promise.all([
      postCandidateKnowledge(localStorage.getItem("candidateId"), {
        capacitations: [],
        languages: [
          {
            ...dataEnglish,
            language_level_id: Number(dataEnglish.language_level_id),
          },
        ],
      }),
      postCandidateEducation(localStorage.getItem("candidateId"), [{ capacitations: [], ...dataFormation, formation_level_id: Number(dataFormation.formation_level_id) }]),
    ]);

    if (respKnowledge.items.message === "Updated candidate " && respEducation.items.message === "Updated candidate") {
      history.push("/candidate/miniprofile");
      setIsLoading(false);
    } else {
      Swal.fire({
        title: "Hola 👋",
        text: "Algo ha ido mal, inténtalo más tarde!",
        icon: "info",
        confirmButtonText: "Ok",
      });
      setIsLoading(false);
    }
  };

  const isFormValid = () => {
    return (
      dataEnglish.language_level_id === "" ||
      dataFormation.name === "" ||
      dataFormation.entry_date === "" ||
      dataFormation.university === "0" ||
      dataFormation.formation_level_id === "0" ||
      dataFormation.departure_date === "" ||
      dataFormation.departure_date === false ||
      dataFormation.departure_date < dataFormation.entry_date
    );
  };

  const handleChangeCheckBox = (e) => {
    const { name, checked } = e.target;
    setCheckBoxValue(checked);

    if (checked) {
      setDataFormation((prevData) => ({
        ...prevData,
        departure_date: "En curso",
      }));
    } else {
      setDataFormation((prevData) => ({
        ...prevData,
        departure_date: false,
      }));
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className=" me-5 text-white w-100">
          <div className="mb-3" style={{ color: "#41C8FF" }}>
            Etapa 3 de 3
          </div>
          <h3>
            <strong>{firstLoginTranslate.step3FirstLoginTitle}</strong>
          </h3>
          <div className="mb-3 text-gray">{firstLoginTranslate.step3FirstLoginText}</div>

          <div className="step2-form p-0 mt-5">
            <div className="mb-5 row">
              <h4 className="pb-3">{firstLoginTranslate.step3Formation}</h4>
              <div className="col">
                <CustomInput label={firstLoginTranslate.step3University} value={dataFormation.name} name={"name"} onChange={handleChange} />
              </div>
              <div className="col">
                <CustomInput label={firstLoginTranslate.step3Career} value={dataFormation.university} name={"university"} onChange={handleChange} />
              </div>
              <div className="col">
                <CustomSelect
                  label={firstLoginTranslate.step3Type}
                  list={typeList}
                  value={dataFormation.formation_level_id}
                  name={"formation_level_id"}
                  propriety={"name"}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-5 row">
              <div className={`${dataFormation.departure_date === "En curso" ? "col-4" : "col"} pt-1`}>
                <CustomCheckBox
                  title={firstLoginTranslate.step3Studing}
                  label={language === "PT-BR" ? "Sim" : "Sí"}
                  value={dataFormation.departure_date === "En curso" ? true : false}
                  name={"departure_date"}
                  onChange={handleChangeCheckBox}
                />
              </div>
              <div className={`${dataFormation.departure_date === "En curso" ? "col-4" : "col"}`}>
                <CustomDateInput value={dataFormation.entry_date} label={firstLoginTranslate.step3StartDate} name={"entry_date"} onChange={handleChange} />
              </div>
              {dataFormation.departure_date !== "En curso" && (
                <div className="col">
                  <CustomDateInput value={dataFormation.departure_date} label={firstLoginTranslate.step3EndDate} name={"departure_date"} onChange={handleChange} />
                </div>
              )}
            </div>
          </div>

          <div className="mb-5 row">
            <h4 className="pb-3">{firstLoginTranslate.step3English}</h4>
            <div className="custom-label fw-bold d-flex mb-2" style={{ color: "#CACCFC" }}>
              Nivel *
            </div>
            <div className="col">
              <div className="d-flex">
                <CustomRadioBtn
                  label={firstLoginTranslate.step3Basic}
                  id={1}
                  name="language_level_id"
                  value="1"
                  checked={dataEnglish.language_level_id.toString() === "1"}
                  onChange={() => handleChangeRadio("1")}
                />
                <CustomRadioBtn
                  label={firstLoginTranslate.step3Intermediate}
                  id={2}
                  name="language_level_id"
                  value="2"
                  checked={dataEnglish.language_level_id.toString() === "2"}
                  onChange={() => handleChangeRadio("2")}
                />
                <CustomRadioBtn
                  label={firstLoginTranslate.step3Advanced}
                  id={3}
                  name="language_level_id"
                  value="3"
                  checked={dataEnglish.language_level_id.toString() === "3"}
                  onChange={() => handleChangeRadio("3")}
                />
                <CustomRadioBtn
                  label={firstLoginTranslate.step3Fluent}
                  id={4}
                  name="language_level_id"
                  value="4"
                  checked={dataEnglish.language_level_id.toString() === "4"}
                  onChange={() => handleChangeRadio("4")}
                />
              </div>
            </div>
          </div>

          <button className="custom-btn mt-5" disabled={isFormValid()} style={{ backgroundColor: isFormValid() ? "gray" : "" }} onClick={handleStartClick}>
            {firstLoginTranslate.firstLoginBtn}
          </button>
        </div>
      )}
    </>
  );
};

export default Step3FirstLogin;
